import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "footer py-4 d-flex flex-lg-column",
  id: "kt_footer"
}
const _hoisted_2 = { class: "d-flex justify-content-end flex-md-row align-items-center container" }
const _hoisted_3 = { class: "text-dark order-2 order-md-1" }
const _hoisted_4 = { class: "text-muted fw-bold me-2" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("a", {
  href: "https://agroru.com/",
  target: "_blank",
  class: "text-gray-800 text-hover-primary"
}, " Агрору ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(new Date().getFullYear()) + "© ", 1),
        _hoisted_5
      ])
    ])
  ]))
}